import Modal from 'modal-enhanced-react-native-web';
import React, { Component } from 'react';
  const ModalDate = ({ children,isVisible,measure,source }) => {
    return (
      <Modal
      isVisible={isVisible}
      style={[
        // styles.ModalStyle,
        // styles[getResponsiveStyle('ModalStyle', measure)]
        {display:'flex',justifyContent:'center',alignItems:'center',alignContent:'center',},
      ]}
      >
        {children}
      </Modal>
    );
  };
  
  export default ModalDate;